// extracted by mini-css-extract-plugin
module.exports = {"tab-li":"MediaPlayer-module--tab-li--Ehokp","active-tab":"MediaPlayer-module--active-tab--35evz","tab-content":"MediaPlayer-module--tab-content--3biKW"};